<template>
  <v-card
    :loading="loading"
    @click="$emit('select', counter.eventValue)"
  >
    <v-card-text class="d-flex align-center justify-space-between pa-4">
      <div>
        <h2 class="font-weight-semibold mb-1">
          {{ counter.quantity }}
        </h2>
        <span>{{ counter.title }}</span>
      </div>

      <v-avatar class="v-avatar-light-bg primary--text">
        <v-icon
          size="25"
          class="rounded-0"
          :color="counter.icon.color"
        >
          {{ counter.icon.shape }}
        </v-icon>
      </v-avatar>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    loading: Boolean,
    counter: {
      type: Object,
      required: true,
    },
  },

  emits: ['select'],
}
</script>
